// Deprecated

"use strict";

module.exports = function (obj) {
 return typeof obj === "function";
};



//////////////////
// WEBPACK FOOTER
// ./~/es5-ext/object/is-callable.js
// module id = 9
// module chunks = 0


// WEBPACK FOOTER //
// webpack:///~/es5-ext/object/is-callable.js